if(window.customer != undefined){ 
  var customerID = JSON.stringify(window.customer.id);
  var customerEmail = window.customer.email;
  var customerFirstName = JSON.stringify(window.customer.firstName);
  var customerLastName = JSON.stringify(window.customer.lastName);
  var customerPhone = JSON.stringify(window.customer.phone);
  var customerDefaultAddress = JSON.stringify(window.customer.defaultAddress);
  let customerData = {
      customerID: customerID,
      customerEmail: customerEmail,
      customerFirstName: customerFirstName,
      customerLastName: customerLastName,
      customerPhone: customerPhone,
      customerDefaultAddress: customerDefaultAddress,
  };

  // On checkout page get cart data
  $(document).on("click", "#checkout_btn", function (e) {
    e.preventDefault();

    var $checkoutBtn = $(this);

    if ($checkoutBtn.data("processing")) return;
    $checkoutBtn.data("processing", true);

    $.ajax({
      type: "GET",
      url: "/cart.js",
      dataType: "json",
      cache: false,
      success: function (cart) {
        if (cart.item_count <= 0) {
          $checkoutBtn.data("processing", false);
          return;
        }

        var inventoryChecks = [];

        $.each(cart.items, function (index, item) {
          var check = $.ajax({
            type: "GET",
            url: "/products/" + item.handle + ".js",
            dataType: "json",
            cache: false
          }).then(function (product) {
            var variant = null;

            $.each(product.variants, function (i, productVariant) {
              if (productVariant.id == item.variant_id) {
                variant = productVariant;
                return false;
              }
            });

            if (!variant) {
              return {
                available: false,
                item: item,
                productTitle: item.product_title,
                variantTitle: item.variant_title
              };
            }

            return {
              available: variant.available,
              item: item,
              productTitle: item.product_title,
              variantTitle: item.variant_title
            };
          }, function () {
            return {
              available: false,
              item: item,
              productTitle: item.product_title,
              variantTitle: item.variant_title
            };
          });

          inventoryChecks.push(check);
        });

        $.when.apply($, inventoryChecks).then(function () {
          var results = Array.prototype.slice.call(arguments);

          if (inventoryChecks.length === 1) {
            results = [arguments[0]];
          }

          var unavailableItems = [];

          $.each(results, function (index, result) {
            if (!result.available) {
              unavailableItems.push({
                productTitle: result.productTitle,
                variantTitle: result.variantTitle
              });
            }
          });

          if (unavailableItems.length > 0) {
            var html = "<strong>Vissa varor finns inte längre tillgängliga:</strong><ul>";

            $.each(unavailableItems, function (index, item) {
              html += "<li><strong>" + escapeHtml(item.productTitle) + "</strong>";

              if (item.variantTitle && item.variantTitle !== "Default Title") {
                html += " — " + escapeHtml(item.variantTitle);
              }

              html += " finns inte längre tillgänglig. Vänligen ta bort den från din varukorg.</li>";
            });

            html += "</ul>";

            $(".checkout-inventory-error").html(html).show();

            $checkoutBtn.data("processing", false);
            return;
          }

          var cData = {
            cartData: cart,
            customerData: customerData
          };

          var utf8EncodedString = encodeURIComponent(JSON.stringify(cData));
          var base64EncodedString = btoa(utf8EncodedString);

          var form = document.createElement("form");
          form.method = "POST";
          form.action = "http://server.richyhair.se/";

          var input = document.createElement("input");
          input.type = "hidden";
          input.name = "cartData";
          input.value = base64EncodedString;

          form.appendChild(input);
          document.body.appendChild(form);
          form.submit();

        }, function (error) {
          console.error("Inventory check error:", error);
          $checkoutBtn.data("processing", false);
        });
      },
      error: function (error) {
        console.error("Cart error:", error);
        $checkoutBtn.data("processing", false);
      }
    });
  });

  function escapeHtml(text) {
    var div = document.createElement("div");
    div.textContent = text || "";
    return div.innerHTML;
  }

  document.addEventListener("DOMContentLoaded", function () {
    var errorBoxes = document.querySelectorAll(".checkout-inventory-error");
    var storedError = sessionStorage.getItem("checkoutInventoryError");

    if (!errorBoxes.length || !storedError) return;

    try {
      var unavailableItems = JSON.parse(storedError);

      if (unavailableItems.length > 0) {
        var html = "<strong>Some items are no longer available:</strong><ul>";

        unavailableItems.forEach(function (item) {
          html += "<li><strong>" + escapeHtml(item.productTitle) + "</strong>";

          if (item.variantTitle && item.variantTitle !== "Default Title") {
            html += " — " + escapeHtml(item.variantTitle);
          }

          html += " is no longer available. Please remove it from your cart.</li>";
        });

        html += "</ul>";

        errorBoxes.forEach(function (box) {
          box.innerHTML = html;
          box.style.display = "block";
        });
      }

      sessionStorage.removeItem("checkoutInventoryError");

    } catch (error) {
      console.error("Inventory error display:", error);
      sessionStorage.removeItem("checkoutInventoryError");
    }

    function escapeHtml(text) {
      var div = document.createElement("div");
      div.textContent = text || "";
      return div.innerHTML;
    }
  });
}